import React, { useEffect, useState } from 'react';
import useUserStore from '../../stores/userStore';
import { UsuarioUtils } from '../../model/Usuario/Usuario';
import { PermissaoEnum } from '../../model/Usuario/Permissao';
import { useBreadcrumbs } from '../../Routes/BreadcrumbContext';
import { createBreadcrumbs } from '../../utils/breadcrumbUtils';
import EstatisticasPublicasComponent from '../../components/EstatisticasPublicas';
import { BancaViewModel } from '../../viewmodel/banca/BancaViewModel';
import BancasModal from './BancasModal';

interface BancaData {
  id: string;
  processoId: string;
  status: string;
  processoNome: string;
  tipoBanca: string;
  membros: string[];
  data: string;
  horaInicial: string;
  horaFinal: string;
  salaDeBanca: string;
  dataFinalizacao?: string;
}

const Home: React.FC = () => {
  const { setBreadcrumbs } = useBreadcrumbs();
  const usuario = useUserStore((state: any) => state.usuario);
  const [bancas, setBancas] = useState<BancaData[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const temPermissaoConsultarProcesso = usuario && UsuarioUtils.verificarTodasPermissoes(usuario, [PermissaoEnum.CONSULTAR_PROCESSO]);

  useEffect(() => {
    if (temPermissaoConsultarProcesso) {
      setBreadcrumbs(createBreadcrumbs.fromProcessos());
    } else {
      setBreadcrumbs(createBreadcrumbs.home());
    }
  }, [setBreadcrumbs, temPermissaoConsultarProcesso]);

  useEffect(() => {
    const carregarBancas = async () => {
      try {
        const response = await BancaViewModel.getBancasParaMembro();
        const bancasFormatadas: BancaData[] = response.bancas.map(banca => ({
          id: banca.id,
          processoId: banca.processoId,
          status: banca.status || '',
          processoNome: banca.processoNome || '',
          tipoBanca: banca.tipoBanca || '',
          membros: banca.membros || [],
          data: banca.data || '',
          horaInicial: banca.horaInicial || '',
          horaFinal: banca.horaFinal || '',
          salaDeBanca: banca.salaDeBanca || '',
          dataFinalizacao: banca.dataFinalizacao || undefined
        }));
        setBancas(bancasFormatadas);
        if (bancasFormatadas.length > 0) {
          setIsModalOpen(true);
        }
      } catch (error) {
        console.error('Erro ao carregar bancas:', error);
      }
    };

    carregarBancas();
  }, []);


  return (
    <>
      <EstatisticasPublicasComponent />
      <BancasModal 
        bancas={bancas}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default Home;